import React, { useState, useEffect } from 'react';
import ComunicacionModel from '../../models/ComunicacionModel';
import ClienteModel from '../../models/ClienteModel';
import './admin.css';

const AdminCorreos = () => {
  const [comunicaciones, setComunicaciones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEnvioForm, setShowEnvioForm] = useState(false);
  const [stats, setStats] = useState({});
  const [formData, setFormData] = useState({
    cliente_id: '',
    asunto: '',
    mensaje: '',
    tipo: 'manual'
  });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      const [comunicacionesData, clientesData, statsData] = await Promise.all([
        ComunicacionModel.getAll(),
        ClienteModel.getNewsletter(),
        ComunicacionModel.getStats()
      ]);
      setComunicaciones(comunicacionesData);
      setClientes(clientesData);
      setStats(statsData);
    } catch (error) {
      console.error('Error cargando datos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEnviarCorreo = async (e) => {
    e.preventDefault();
    try {
      await ComunicacionModel.send(formData);
      alert('Correo enviado exitosamente');
      setShowEnvioForm(false);
      setFormData({ cliente_id: '', asunto: '', mensaje: '', tipo: 'manual' });
      cargarDatos();
    } catch (error) {
      console.error('Error enviando correo:', error);
      alert('Error al enviar correo');
    }
  };

  const getTipoLabel = (tipo) => {
    const tipos = {
      'manual': 'Manual',
      'promocion': 'Promoción',
      'confirmacion_pedido': 'Confirmación de Pedido',
      'confirmacion_tour': 'Confirmación de Tour'
    };
    return tipos[tipo] || tipo;
  };

  const getEstadoBadge = (estado) => {
    const clases = {
      'enviado': 'badge-success',
      'pendiente': 'badge-warning',
      'fallido': 'badge-danger'
    };
    return <span className={`badge ${clases[estado] || ''}`}>{estado}</span>;
  };

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleString('es-MX');
  };

  if (loading) return <div className="loading">Cargando sistema de correos...</div>;

  return (
    <div className="admin-correos">
      <div className="page-header">
        <div>
          <h1>📧 Administración de Correos</h1>
          <p>Gestiona las comunicaciones con clientes</p>
        </div>
        <button onClick={() => setShowEnvioForm(!showEnvioForm)} className="btn-primary">
          {showEnvioForm ? 'Cancelar' : '+ Nuevo Correo'}
        </button>
      </div>

      {/* Estadísticas */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📨</div>
          <div className="stat-info">
            <span className="stat-label">Correos Enviados</span>
            <span className="stat-number">{stats.total_enviados || 0}</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">👁️</div>
          <div className="stat-info">
            <span className="stat-label">Tasa de Apertura</span>
            <span className="stat-number">{stats.tasa_apertura || '0%'}</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🔗</div>
          <div className="stat-info">
            <span className="stat-label">Tasa de Click</span>
            <span className="stat-number">{stats.tasa_click || '0%'}</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">👥</div>
          <div className="stat-info">
            <span className="stat-label">Clientes Suscritos</span>
            <span className="stat-number">{stats.clientes_suscritos || 0}</span>
          </div>
        </div>
      </div>

      {/* Formulario de envío */}
      {showEnvioForm && (
        <div className="form-section">
          <h2>Enviar Nuevo Correo</h2>
          <form onSubmit={handleEnviarCorreo}>
            <div className="form-grid">
              <div className="form-group full-width">
                <label>Cliente</label>
                <select name="cliente_id" value={formData.cliente_id} onChange={handleInputChange}>
                  <option value="">Todos los clientes suscritos</option>
                  {clientes.map(cliente => (
                    <option key={cliente.id} value={cliente.id}>
                      {cliente.nombre} - {cliente.email}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group full-width">
                <label>Tipo de correo</label>
                <select name="tipo" value={formData.tipo} onChange={handleInputChange}>
                  <option value="manual">Correo Manual</option>
                  <option value="promocion">Promoción</option>
                  <option value="confirmacion_pedido">Confirmación de Pedido</option>
                  <option value="confirmacion_tour">Confirmación de Tour</option>
                </select>
              </div>

              <div className="form-group full-width">
                <label>Asunto</label>
                <input
                  type="text"
                  name="asunto"
                  value={formData.asunto}
                  onChange={handleInputChange}
                  placeholder="Ej: Oferta especial para ti"
                  required
                />
              </div>

              <div className="form-group full-width">
                <label>Mensaje</label>
                <textarea
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleInputChange}
                  rows="8"
                  placeholder="Escribe el contenido del correo..."
                  required
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary btn-large">
                Enviar Correo
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Historial de comunicaciones */}
      <div className="comunicaciones-section">
        <h2>Historial de Comunicaciones</h2>
        <div className="table-responsive">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Tipo</th>
                <th>Asunto</th>
                <th>Cliente</th>
                <th>Email</th>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {comunicaciones.map(com => (
                <tr key={com.id}>
                  <td>#{com.id}</td>
                  <td>{getTipoLabel(com.tipo)}</td>
                  <td>{com.asunto}</td>
                  <td>{com.cliente_nombre || '—'}</td>
                  <td>{com.cliente_email || '—'}</td>
                  <td>{formatearFecha(com.fecha)}</td>
                  <td>{getEstadoBadge(com.estado)}</td>
                  <td>
                    <button className="btn-icon" title="Ver detalles">👁️</button>
                    <button className="btn-icon" title="Reenviar">🔄</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminCorreos;